export class Norma {
  id_norma: number;
  abr: string;
  descripcion: string;
  id_ambito: number;
  id_ambito_internacional: number;
  id_ambito_nacional: number;
  id_ambito_autonomico: number;
  id_ambito_provincial: number;
  id_ambito_local: number;
  id_modulo: number;
  id_bloque: number;
  id_area: number;
  id_copia: number;
  comentarios: any=[];
  enlaces: any=[];
  ambito: string;
  bloque: string;
  area: string;
  modulo: string;
  areas: any = [];
  ambitoNacional: any = "";
  ambitoInternacional: any = "";
  ambitoLocal: any = "";
  ambitoProvincial: any = "";
  ambitoAutonomico: any = "";
  finalizado: any = 0;
  revisado: any = 0;
  realizado: any = 0;
  observacion_interna: any = "";

  constructor(){
    this.id_norma = 0;
    this.abr = "";
    this.descripcion = "";
    this.id_ambito = 1;
    this.id_ambito_internacional = 0;
    this.id_ambito_nacional = 0;
    this.id_ambito_autonomico = 0;
    this.id_ambito_provincial = 0;
    this.id_ambito_local = 0;
    this.id_modulo = 0;
    this.id_bloque = 0;
    this.id_area = 0;
    this.ambito = "";
    this.bloque = "";
    this.area = "";
    this.modulo = "";
    this.id_copia = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/norma.model.ts